const strategyConfigs = {
    "vol": "vol_strategy_config",
    "Portfolio": "account_summary_config",
    "hft": "hft_strategy_config",
    "cta": "cta_strategy_config",
    "funding": "funding_strategy_config",
    "option": "option_strategy_config",
    "otc": "otc_strategy_config",
    "hftmm": "hftmm_strategy_config",
    "jun": "jun_strategy_config",
    "xue": "xue_strategy_config",
    "corvol": "corvol_strategy_config",
};

export default strategyConfigs;


// WEBPACK FOOTER //
// ./src/component/strategy-configs.js